import React, { useState } from 'react';
import { ChevronRight, ChevronLeft, FileText, Users, Building2, Download, Eye } from 'lucide-react';
import { PdfViewerModal } from '../components/modals/PdfViewerModal';
interface DettaglioRichiestaPageProps {
  requestId: string;
  companyName: string;
  submissionDate: string;
  onBack: () => void;
}
interface AziendaData {
  ragioneSociale: string;
  partitaIva: string;
  codiceFiscale: string;
  sedeLegale: string;
  citta: string;
  cap: string;
  provincia: string;
  telefono: string;
  email: string;
  pec: string;
  legaleRappresentante: string;
}
interface CantiereData {
  indirizzo: string;
  citta: string;
  cap: string;
  provincia: string;
  dataInizio: string;
  dataFine: string;
  descrizione: string;
  committente: string;
  importoLavori: string;
}
interface LavoratoreData {
  nome: string;
  cognome: string;
  codiceFiscale: string;
  dataNascita: string;
  luogoNascita: string;
  mansione: string;
  dataInizioDistacco: string;
  dataFineDistacco: string;
}
interface DocumentoData {
  nome: string;
  tipo: 'Dati Cantiere' | 'Dati Lavoratori';
  dataCaricamento: string;
  dimensione: string;
  url: string;
}
// Mock data
const mockAziendaData: AziendaData = {
  ragioneSociale: 'Costruzioni Italia S.r.l.',
  partitaIva: '12345678901',
  codiceFiscale: '12345678901',
  sedeLegale: 'Via Roma, 123',
  citta: 'Milano',
  cap: '20100',
  provincia: 'MI',
  telefono: '+39 02 1234567',
  email: 'info@costruzioniitalia.it',
  pec: 'costruzioniitalia@pec.it',
  legaleRappresentante: 'Mario Bianchi'
};
const mockCantiereData: CantiereData = {
  indirizzo: 'Rue de la Paix, 123',
  citta: 'Parigi',
  cap: '75002',
  provincia: 'Île-de-France',
  dataInizio: '01/03/2024',
  dataFine: '31/12/2024',
  descrizione: 'Ristrutturazione edificio storico nel centro di Parigi',
  committente: 'Société Immobilière Paris S.A.',
  importoLavori: '€ 2.500.000'
};
const mockLavoratoriData: LavoratoreData[] = [{
  nome: 'Mario',
  cognome: 'Rossi',
  codiceFiscale: 'RSSMRA80A01H501Z',
  dataNascita: '01/01/1980',
  luogoNascita: 'Roma',
  mansione: 'Capo Cantiere',
  dataInizioDistacco: '01/03/2024',
  dataFineDistacco: '31/12/2024'
}, {
  nome: 'Giuseppe',
  cognome: 'Verdi',
  codiceFiscale: 'VRDGPP85B15F205K',
  dataNascita: '15/02/1985',
  luogoNascita: 'Milano',
  mansione: 'Muratore Specializzato',
  dataInizioDistacco: '01/03/2024',
  dataFineDistacco: '31/12/2024'
}, {
  nome: 'Luca',
  cognome: 'Bianchi',
  codiceFiscale: 'BNCLCU90C20L219P',
  dataNascita: '20/03/1990',
  luogoNascita: 'Torino',
  mansione: 'Elettricista',
  dataInizioDistacco: '15/03/2024',
  dataFineDistacco: '31/12/2024'
}];
const mockDocumentiData: DocumentoData[] = [{
  nome: 'Modulo_Dati_Cantiere_Parigi.pdf',
  tipo: 'Dati Cantiere',
  dataCaricamento: '10/01/2024 14:30',
  dimensione: '2.4 MB',
  url: 'https://www.tessutifiorito.it/Pub/Files/202104/38_File_di_esempio.pdf'
}, {
  nome: 'Modulo_Dati_Lavoratori_Parigi.pdf',
  tipo: 'Dati Lavoratori',
  dataCaricamento: '10/01/2024 14:32',
  dimensione: '1.8 MB',
  url: 'https://www.tessutifiorito.it/Pub/Files/202104/38_File_di_esempio.pdf'
}];
type TabType = 'azienda' | 'cantiere' | 'lavoratori' | 'documenti';
export function DettaglioRichiestaPage({
  requestId,
  companyName,
  submissionDate,
  onBack
}: DettaglioRichiestaPageProps) {
  const [activeTab, setActiveTab] = useState<TabType>('azienda');
  const [isPdfViewerOpen, setIsPdfViewerOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState<DocumentoData | null>(null);
  const handleDownload = (documento: DocumentoData) => {
    window.open(documento.url, '_blank');
  };
  const handleView = (documento: DocumentoData) => {
    setSelectedPdf(documento);
    setIsPdfViewerOpen(true);
  };
  return <div className="space-y-4 lg:space-y-6" data-id="element-287">
      {/* Breadcrumb and Header */}
      <div className="space-y-3" data-id="element-288">
        <nav className="flex items-center text-sm text-gray-600" data-id="element-289">
          <button onClick={onBack} className="p-1 hover:bg-gray-100 rounded transition-colors mr-2" title="Torna indietro" data-id="element-290">
            <ChevronLeft size={20} data-id="element-291" />
          </button>
          <button onClick={onBack} className="hover:text-gray-900 transition-colors" data-id="element-292">
            Richieste di Esonero
          </button>
          <ChevronRight size={16} className="mx-2" data-id="element-293" />
          <span className="text-gray-900 font-medium" data-id="element-294">{requestId}</span>
        </nav>

        <div data-id="element-295">
          <h1 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-296">
            Dettaglio Richiesta {companyName} del {submissionDate}
          </h1>
          <p className="text-sm lg:text-base text-gray-600 mt-1" data-id="element-297">
            Visualizza i dettagli della richiesta di esonero
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-lg shadow" data-id="element-298">
        <div className="border-b border-gray-200" data-id="element-299">
          <nav className="flex -mb-px overflow-x-auto" data-id="element-300">
            <button onClick={() => setActiveTab('azienda')} className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'azienda' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'}`} data-id="element-301">
              <Building2 size={20} data-id="element-302" />
              <span data-id="element-303">Dati Azienda</span>
            </button>
            <button onClick={() => setActiveTab('cantiere')} className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'cantiere' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'}`} data-id="element-304">
              <FileText size={20} data-id="element-305" />
              <span data-id="element-306">Dati Cantiere</span>
            </button>
            <button onClick={() => setActiveTab('lavoratori')} className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'lavoratori' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'}`} data-id="element-307">
              <Users size={20} data-id="element-308" />
              <span data-id="element-309">Dati Lavoratori</span>
            </button>
            <button onClick={() => setActiveTab('documenti')} className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'documenti' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'}`} data-id="element-310">
              <Download size={20} data-id="element-311" />
              <span data-id="element-312">Documenti</span>
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6" data-id="element-313">
          {activeTab === 'azienda' && <div className="space-y-6" data-id="element-314">
              {/* Informazioni Generali */}
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-315">
                <h3 className="text-md font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-316">
                  <Building2 size={18} className="text-blue-600" data-id="element-317" />
                  Informazioni Generali
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-318">
                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-319">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-320">
                      Ragione Sociale
                    </label>
                    <p className="text-sm text-gray-900 font-semibold" data-id="element-321">
                      {mockAziendaData.ragioneSociale}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-322">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-323">
                      Legale Rappresentante
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-324">
                      {mockAziendaData.legaleRappresentante}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-325">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-326">
                      Partita IVA
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-327">
                      {mockAziendaData.partitaIva}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-328">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-329">
                      Codice Fiscale
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-330">
                      {mockAziendaData.codiceFiscale}
                    </p>
                  </div>
                </div>
              </div>

              {/* Sede Legale */}
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-331">
                <h3 className="text-md font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-332">
                  <FileText size={18} className="text-blue-600" data-id="element-333" />
                  Sede Legale
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-334">
                  <div className="bg-white rounded p-3 border border-gray-100 md:col-span-2" data-id="element-335">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-336">
                      Indirizzo
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-337">
                      {mockAziendaData.sedeLegale}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-338">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-339">
                      Città
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-340">
                      {mockAziendaData.citta}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-341">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-342">
                      Provincia
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-343">
                      {mockAziendaData.provincia}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-344">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-345">
                      CAP
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-346">
                      {mockAziendaData.cap}
                    </p>
                  </div>
                </div>
              </div>

              {/* Contatti */}
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-347">
                <h3 className="text-md font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-348">
                  <Users size={18} className="text-blue-600" data-id="element-349" />
                  Contatti
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-350">
                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-351">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-352">
                      Telefono
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-353">
                      {mockAziendaData.telefono}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-354">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-355">
                      Email
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-356">
                      {mockAziendaData.email}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100 md:col-span-2" data-id="element-357">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-358">
                      PEC
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-359">
                      {mockAziendaData.pec}
                    </p>
                  </div>
                </div>
              </div>
            </div>}

          {activeTab === 'cantiere' && <div className="space-y-6" data-id="element-360">
              {/* Localizzazione */}
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-361">
                <h3 className="text-md font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-362">
                  <FileText size={18} className="text-blue-600" data-id="element-363" />
                  Localizzazione Cantiere
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-364">
                  <div className="bg-white rounded p-3 border border-gray-100 md:col-span-2" data-id="element-365">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-366">
                      Indirizzo
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-367">
                      {mockCantiereData.indirizzo}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-368">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-369">
                      Città
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-370">
                      {mockCantiereData.citta}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-371">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-372">
                      Provincia
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-373">
                      {mockCantiereData.provincia}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-374">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-375">
                      CAP
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-376">
                      {mockCantiereData.cap}
                    </p>
                  </div>
                </div>
              </div>

              {/* Dettagli Lavori */}
              <div className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-377">
                <h3 className="text-md font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-378">
                  <Building2 size={18} className="text-blue-600" data-id="element-379" />
                  Dettagli Lavori
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-380">
                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-381">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-382">
                      Data Inizio Lavori
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-383">
                      {mockCantiereData.dataInizio}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-384">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-385">
                      Data Fine Lavori
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-386">
                      {mockCantiereData.dataFine}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-387">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-388">
                      Committente
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-389">
                      {mockCantiereData.committente}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100" data-id="element-390">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-391">
                      Importo Lavori
                    </label>
                    <p className="text-sm text-gray-900 font-semibold" data-id="element-392">
                      {mockCantiereData.importoLavori}
                    </p>
                  </div>

                  <div className="bg-white rounded p-3 border border-gray-100 md:col-span-2" data-id="element-393">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-394">
                      Descrizione Lavori
                    </label>
                    <p className="text-sm text-gray-900" data-id="element-395">
                      {mockCantiereData.descrizione}
                    </p>
                  </div>
                </div>
              </div>
            </div>}

          {activeTab === 'lavoratori' && <div className="space-y-4" data-id="element-396">
              {mockLavoratoriData.map((lavoratore, index) => <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-397">
                  <div className="flex items-start justify-between mb-4" data-id="element-398">
                    <div data-id="element-399">
                      <h3 className="font-semibold text-gray-900 text-lg" data-id="element-400">
                        {lavoratore.nome} {lavoratore.cognome}
                      </h3>
                      <p className="text-sm text-gray-600 mt-1" data-id="element-401">
                        {lavoratore.mansione}
                      </p>
                    </div>
                    <span className="px-3 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full" data-id="element-402">
                      Lavoratore {index + 1}
                    </span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-403">
                    <div className="bg-white rounded p-3 border border-gray-100" data-id="element-404">
                      <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-405">
                        Codice Fiscale
                      </label>
                      <p className="text-sm text-gray-900 font-mono" data-id="element-406">
                        {lavoratore.codiceFiscale}
                      </p>
                    </div>

                    <div className="bg-white rounded p-3 border border-gray-100" data-id="element-407">
                      <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-408">
                        Data di Nascita
                      </label>
                      <p className="text-sm text-gray-900" data-id="element-409">
                        {lavoratore.dataNascita}
                      </p>
                    </div>

                    <div className="bg-white rounded p-3 border border-gray-100" data-id="element-410">
                      <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-411">
                        Luogo di Nascita
                      </label>
                      <p className="text-sm text-gray-900" data-id="element-412">
                        {lavoratore.luogoNascita}
                      </p>
                    </div>

                    <div className="bg-white rounded p-3 border border-gray-100" data-id="element-413">
                      <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-414">
                        Inizio Distacco
                      </label>
                      <p className="text-sm text-gray-900" data-id="element-415">
                        {lavoratore.dataInizioDistacco}
                      </p>
                    </div>

                    <div className="bg-white rounded p-3 border border-gray-100" data-id="element-416">
                      <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-417">
                        Fine Distacco
                      </label>
                      <p className="text-sm text-gray-900" data-id="element-418">
                        {lavoratore.dataFineDistacco}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>}

          {activeTab === 'documenti' && <div className="space-y-4" data-id="element-419">
              <div className="flex items-center justify-between mb-4" data-id="element-420">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-421">
                  Documenti Caricati ({mockDocumentiData.length})
                </h2>
              </div>

              {mockDocumentiData.map((documento, index) => <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200 hover:border-gray-300 transition-colors" data-id="element-422">
                  <div className="flex items-start justify-between" data-id="element-423">
                    <div className="flex items-start gap-4 flex-1" data-id="element-424">
                      <div className="p-3 bg-blue-100 rounded-lg" data-id="element-425">
                        <FileText size={24} className="text-blue-600" data-id="element-426" />
                      </div>
                      <div className="flex-1" data-id="element-427">
                        <h3 className="font-semibold text-gray-900 mb-1" data-id="element-428">
                          {documento.nome}
                        </h3>
                        <div className="flex flex-wrap items-center gap-3 text-sm text-gray-600" data-id="element-429">
                          <span className="flex items-center gap-1" data-id="element-430">
                            <span className="font-medium" data-id="element-431">Tipo:</span>
                            <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded text-xs font-medium" data-id="element-432">
                              {documento.tipo}
                            </span>
                          </span>
                          <span data-id="element-433">•</span>
                          <span data-id="element-434">{documento.dimensione}</span>
                          <span data-id="element-435">•</span>
                          <span data-id="element-436">Caricato il {documento.dataCaricamento}</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 ml-4" data-id="element-437">
                      <button onClick={() => handleView(documento)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="Visualizza PDF" data-id="element-438">
                        <Eye size={20} data-id="element-439" />
                      </button>
                      <button onClick={() => handleDownload(documento)} className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors" title="Scarica PDF" data-id="element-440">
                        <Download size={20} data-id="element-441" />
                      </button>
                    </div>
                  </div>
                </div>)}

              {mockDocumentiData.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-442">
                  <FileText size={48} className="mx-auto mb-4 text-gray-400" data-id="element-443" />
                  <p data-id="element-444">Nessun documento caricato</p>
                </div>}
            </div>}
        </div>
      </div>

      {/* PDF Viewer Modal */}
      {selectedPdf && <PdfViewerModal isOpen={isPdfViewerOpen} onClose={() => {
      setIsPdfViewerOpen(false);
      setSelectedPdf(null);
    }} pdfUrl={selectedPdf.url} fileName={selectedPdf.nome} data-id="element-445" />}
    </div>;
}